<template>
  <div class="car-model-layout mb-30">
    <section class="car-list-box">
      <div class="car-head">
        <img v-if="vehItem.topImg1" class="mb-20" :src="vehItem.topImg1" alt="">
      </div>
      <article class="car-list-body">
        <div class="advantage-img">
          <!-- <img v-if="vehItem.topImg1" class="mb-20" :src="vehItem.topImg1" alt=""> -->
          <img v-if="vehItem.topImg1" :src="vehItem.topImg2" alt="">
        </div>
        <ul class="img-group-list-box">
          <li
            class="mr-32"
            v-for="item, index in vehItem.vehicleConfigList"
            :key="index"
            @click="changeVehicle(item)"
          >
            <div class="img-group-box">
              <img class="driver-img" :src="item.img" alt="">
              <p class="tit-1">{{item.name}}</p>
              <p class="tit-2">{{item.introduce}}</p>
              <div class="hll-submit-btn">
                <img class="default-img" :src="item.buttonImg" alt="">
                <span class="small-tit">{{submitTimeValue ? '已预约' : item.buttonText}}</span>
              </div>
              <!-- <div class="small-btn-bg hll-oerder-btn">立即领取优惠</div> -->
            </div>
          </li>
        </ul>
        <template v-if="portType">
          <div class="more-car" :style="{backgroundImage: 'url(' + vehItem.bottomImg + ')'}" @click="goOtherActivity">{{ vehItem.bottomButtonText }}</div>
          <div class="car-buy-footer-box">
            <i>* </i>{{ vehItem.bottomTextDescription }}<i> *</i>
          </div>
        </template>
      </article>
    </section>
  </div>
</template>

<script>
export default {
  props: ["carData", "typeName", "submitTimeValue", "portType", "vehItem"],
  mounted() { 
    console.log("vehItem", this.vehItem)
  },
  methods: {
    changeVehicle(payload) {
      console.log('payload', payload)
    //   {
    //     "id": 1880,
    //     "moduleId": 613,
    //     "img": null,
    //     "carImg": "https://car-stg.oss-cn-shenzhen.aliyuncs.com//lala-mall202303021116221338819767.png",
    //     "carName": "五菱荣光V",
    //     "carIntroduce": "月供1996元",
    //     "btnBackImg": null,
    //     "btnText": null,
    //     "orderNum": 5,
    //     "createAt": null,
    //     "createBy": null,
    //     "updateAt": null,
    //     "updateBy": null
    // }
      this.$emit("changeVehicle", { typeName: this.typeName, datas: payload, btnText: payload.buttonText });
    },
    goOtherActivity() {
      // type url imUrl
      const { redirectType, redirectUrl, bottomImg } = this.vehItem
      this.$emit('goOtherActivity',  redirectType, redirectUrl, bottomImg)
      // this.$emit('goOtherActivity', {
      //   typeName: 'miniprogram',
      //   recordName: '查看更多车型',
      //   openPopupType: 'home',
      //   page: 'page/tabBar/homepage/index'
      // })
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/rpx.scss";
@import "./../common.scss";
.car-model-layout {
  .hll-submit-btn {
    width: rpx(233);
  }
  .success-btn {
    display: block;
    font-size: rpx(24);
    width: rpx(300);
    height: rpx(80);
    border-radius: rpx(80);
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    color: #fff;
    margin: rpx(20) auto;
    background-image: linear-gradient(to right, #ff382f, #ff6631);
  }
}
</style>
